import React from 'react';

import ListCompanies from '../component-list-companies';
import Suspense from '../../Common/components/Suspense-component';

export class CompaniesContainer extends React.Component {

    render() {
        return (
            <Suspense>
                <ListCompanies />
            </Suspense>
        );
    }
}



// WEBPACK FOOTER //
// ./src/customModules/Companies/containers/container-list-companies.js